import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider
} from "@tanstack/react-query";
import type { ReactNode } from "react";

function buildQueryClient() {
  const queryClient = new QueryClient();
  queryClient.setDefaultOptions({
    queries: {
      experimental_prefetchInRender: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity
    },
    mutations: {
      onMutate: context => context
    }
  });
  return queryClient;
}

const queryClient = buildQueryClient();

interface QueryClientProviderProps {
  children: ReactNode;
}

export function QueryClientProvider({ children }: QueryClientProviderProps) {
  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}
